import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import popup from '../../../popup';
import './style.scss';
import '~/assets/css/fitness-globals.scss';
import StripeCCForm from '~/components/StripeCCForm';
import { subscribe, getDiscountPrice } from "~/redux/user/subscription";
import { LoadingIcon } from '~/assets/svg';
import getSymbolFromCurrency from 'currency-symbol-map';
import { format } from 'date-fns';
import { pushFinishSubscriptionEvent } from '~/services/analyticsService';

const iframeInputStyle = {
	base: {
		lineHeight: '26px',
		fontSize: '14px',
		fontFamily: '"Montserrat"',
		'::placeholder': {
			color: '#7a7a7a'
		}
	}
};

class Checkout extends React.Component {

	constructor(props){
		super(props);
		this.state = {
			stripeLoading: false,
			error: null, 
			offerCode: '', 
			promo: null, 
			price: this.props.args.selectedPlan.planDetails[0].recurringPaymentAmount,
			billingDate: format(Date.now(), 'MM/DD/YYYY')
		};
	}

	checkOfferValidity(e) {
		e.preventDefault();
		getDiscountPrice({
			offerCode: this.promoInput.value,
			planId: this.props.args.selectedPlan.id
		}).then( res => {
			this.setState({offerCode: this.promoInput.value, promo: res.data, error: '', billingDate: format(res.data.nextBillingDate, 'MM/DD/YYYY'), price: Math.round(res.data.amount * 100)/100});
		}).catch( error => {
			if(error.response.data.message){
				this.setState({error: error.response.data.message});
			}
			else{
				this.setState({error: 'Not a valid promo code'});
			}
		});
	}

	removePromo(e){
		e.preventDefault();
		this.setState({promo: null, offerCode: '', error: null, price: this.props.args.selectedPlan.planDetails[0].recurringPaymentAmount});
		this.promoInput.value = '';
		this.checkForFreeTrial();
	}

	handleSubmit(e) {
		e.preventDefault();
   		this.setState({stripeLoading: true});

   		//TODO Calling a method a child component goes against the react paradigm. Could use a refactor - placing the submit button in the component
    	this.stripeFormEl.createToken()
      	.then(token => {
	        subscribe({
	            plan: this.props.args.selectedPlan,
	            billingToken: {stripeToken: token},
	            offerCode: this.state.offerCode.toUpperCase().trim()
	        }).then( async res => {
	        	await pushFinishSubscriptionEvent(this.props.args.selectedPlan);
	        	this.props.onClose();
	        	//If first time subscribing
	        	popup.fitnessSetupProfile({
					showCloseButton: false
				});
	        });
      	})
      	.catch(e => {
      		console.log(e);
      		this.setState({ error: (((e || {}).response || {}).data || {}).message || e.message || 'There was an error processing your request.', stripeLoading: false });
	    });
	}

	//Hack to handle using modal on /viewplans
	handleClose() {
		if(window.location.pathname === '/viewplans'){
			window.location.href = "/home";
		}
		this.props.onClose();
	}


	checkForFreeTrial(){
		getDiscountPrice({
			offerCode: '',
			planId: this.props.args.selectedPlan.id
		}).then( res => {
			this.setState({billingDate: format(res.data.nextBillingDate, "MM/DD/YYYY")});
		});
	}

	componentDidMount(){
		//Check for a free trial and increment billing date
		this.checkForFreeTrial();
	}

	//This function renders the submit button to be passed to the stripe form
	renderSubmitButton() {
		const pd = this.props.args.selectedPlan.planDetails[0];
		const firstPayment = `First Payment of ${getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)}${this.state.price} on ${this.state.billingDate}`;
		let buttonText = `PAY ${this.state.price} & SUBSCRIBE`;
		if(format(Date.now(), 'MM/DD/YYYY') !== this.state.billingDate){
			buttonText = 'SUBSCRIBE';
		}

		return (
	    	<div>
	    		<hr/>
	    		<div className="first-payment">{firstPayment}</div>
		        {!this.state.stripeLoading ? <input
			          className='primary-button black button continue-button'
			          type="submit"
			          value={buttonText}
			        />
		    	: <button className='primary-button black button continue-button' disabled>
		        	<LoadingIcon />
		        </button>}
	        </div>
	    );

  	}

	render() {
		return (
			<div className="checkout fitness-modal">
				<div className="close-button" onClick={this.handleClose.bind(this)}><i className="ion-ios-close-empty"/></div>
				<img className="logo-image" src={ _.get(window.settings, 'images.desktopLogo') } alt="Logo" />
				<h2>Secure Checkout</h2>
				<div className="plan-info">
					<h3>NEOU {this.props.args.selectedPlan.name} <span className="right">${this.props.args.selectedPlan.planDetails[0].recurringPaymentAmount}</span></h3>
					<p>Automatically renews until cancelled. To stop, go to Select Cancel Subscription in Settings before next billing date.</p>
					{this.state.promo && <div className="promo-details">
						Promo Code {this.state.offerCode} 
						{this.state.promo.amount && 
						<span className="adjustment right">
							-${+(this.props.args.selectedPlan.planDetails[0].recurringPaymentAmount - this.state.price).toFixed(2)}
							</span>} Applied
						<p>{this.state.promo.offerDescription}</p>
					</div>}
				</div>
				{this.state.promo ? <form className="promo-form" onSubmit={this.removePromo.bind(this)}>
						<input type="text" name="offerCode" placeholder="Promo Code" ref={el => this.promoInput = el} readOnly/>
						<input type="submit" className="primary-button black" value="REMOVE"/>
					</form> : <form className="promo-form" onSubmit={this.checkOfferValidity.bind(this)}>
						<input type="text" name="offerCode" placeholder="Promo Code" ref={el => this.promoInput = el}/>
						<input type="submit" className="primary-button black" value="APPLY"/>
					</form>
				}
				<form onSubmit={this.handleSubmit.bind(this)}>
					{ this.state.error && <div className="error-message">{ this.state.error }</div> }
					<StripeCCForm 
						fonts={[{cssSrc: "https://fonts.googleapis.com/css?family=Montserrat"}]}
						formRef={ el => this.stripeFormEl = el }
						layout="FITNESS"
						apiKey={ ((window.settings.paymentProviders || {}).stripe || {}).apiKey }
						rightContent={this.renderSubmitButton()}
						stripeElStyle={iframeInputStyle}
					/>
				</form>
		  	</div>
		)
	}

}

Checkout.propTypes = {
  onClose: PropTypes.func,
  args: PropTypes.shape({
  	selectedPlan: PropTypes.object.isRequired
  })
};

export default Checkout;